import {css} from '@emotion/css';
import React, {HTMLAttributes} from 'react';
import {theme} from './Common';
import {WarningIcon} from './Icons';

export type WarningBannerProps = {
  children: React.ReactNode;
};

export const WarningBanner = ({children}: WarningBannerProps) => (
  <Container>
    <WarningIcon size='xlarge' />
    {children}
  </Container>
);
const Container = (args: HTMLAttributes<HTMLDivElement>) => (
  <div
    className={css({
      width: '100%',
      background: theme.colors.lightOrange,
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'flex-start',
      flexWrap: 'nowrap',
      padding: `${theme.spacings.medium} ${theme.spacings.large}`,
      svg: {
        marginRight: theme.spacings.medium,
        flexShrink: 0,
        [theme.mediaMaxWidth.medium]: {marginRight: theme.spacings.xsmall},
      },
      [theme.mediaMaxWidth.medium]: {padding: `${theme.spacings.xsmall} ${theme.spacings.small}`},
      ['media (max-width: 550px)']: {padding: `${theme.spacings.medium} ${theme.spacings.large}`},
    })}
    {...args}
  />
);
